module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-view', [_c('div', {
    staticClass: "content"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('movie-cover', {
      key: index,
      attrs: {
        "value": item,
        "more": "simple"
      },
      on: {
        "longTap": _vm.onLongTap
      }
    })
  }), 1), _vm._v(" "), (_vm.list.length === 0) ? _c('div', {
    staticClass: "none"
  }, [_vm._v("暂时没有收藏内容")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("提示：长按可进行删除操作")]), _vm._v(" "), _c('app-confirm', {
    ref: "confirm"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09b183f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/favourite/index.vue
// module id = 306
// module chunks = 0